
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Config from "@/config/config";
import vuexStore from "@/store/vuex-store";
import Count from "@/lib/model/stock/count";
import Auth from "@/lib/common/auth";
import Company from "@/lib/model/company/company";
import User from "@/lib/model/user/user";
import Url from "@/lib/common/url";
import Cookie from "@/lib/common/cookie";
import sensors from "@/lib/thirdparty/sensorsdata.min";
import { Permission } from "@/lib/model/common";
import NR, { CodeForm, LoginFrom, Info, Login } from "@/lib/model/NRXQ/nr";

@Component({ components: {} })
export default class AuthHeader extends Vue {
  name = "auth-header";
  vuexStores = vuexStore;
  count = new Count();
  companies: Company[] = [new Company()];
  token = Auth.token;
  currentCompanyName = "";
  userInfo: User = new User();
  logoutLoading = false;
  companyInfo = new Company();
  isFSK = true;
  showSelectCompany = false; //切换公司
  showSelectHina = false; //切产品

  atsUserOutId = "";
  atsUser: any = {};
  atsCompany: any = {};
  nrToken = "";

  created() {
    if (
      //匿名登录页面： 阅卷 报告（新版报告页现已移出主路由 不会加载head和side了）
      this.$route.name === "paper-mark" ||
      this.$route.name === "paper-mark-mobile" ||
      this.$route.name === "candidate-info" ||
      this.$route.name === "candidates-info"
    )
      return;

    this.nrToken = String(localStorage.getItem("nrToken") || "");
    this.atsUserOutId = String(localStorage.getItem("atsUserOutId") || "");

    this.getUserInfo();
  }
  mounted() {
    // (this.$refs["bg"] as any)?.style?.setProperty("--top-bg", "#525fff");
    // const aa = (this.$refs["bg"] as any)
  }

  get logoUrl() {
    return (
      this.vuexStores.company.logoUrl ||
      this.vuexStores.user.viConfig.specialLogoOss
    );
  }
  get getRoleName() {
    return this.companyInfo.roleName ?? "其他类型成员";
  }
  //是否展示设置按钮 目前是 超管和普管可见
  get canSet() {
    return !this.isFSK && ["1", "2"].includes(this.companyInfo.role);
  }
  get vuexShowCompany() {
    return this.vuexStores.showCompany;
  }
  //vuex里的 卡片显隐
  @Watch("vuexShowCompany")
  VXC(n: boolean) {
    if (n) return;
    this.showSelectHina = n;
    this.showSelectCompany = n;
  }

  toHome() {
    window.location.href = `${Config.apiUrl}/content`;
  }
  //用户信息
  getUserInfo() {
    Login.getUserInfoAfterLogin({ atsUserToken: this.nrToken })
      .then(res => {
        if (res.data.code === 0) {
          this.atsCompany = res.data.data.atsCompany;
          this.atsUser = res.data.data.atsUser;
        }
      })
      .catch(() => {
        //
      });
  }

  logOut() {
    localStorage.removeItem("nrToken");
    localStorage.removeItem("atsUserOutId");
    // localStorage.removeItem("atsCompanyIdOutId")
    this.logoutLoading = true;
    setTimeout(() => {
      window.location.reload();
    }, 500);
  }

  toPersonal() {
    window.open(Config.accountUrl + "/#/user?companyId=" + Auth.companyId);
  }

  toSystem(name: string) {
    let sysUrl = "";
    switch (name) {
      case "vi":
        sysUrl = "https://vi.hina.com/main/project/index-interview";
        break;
      case "exam":
        sysUrl = "https://exam.hina.com";
        break;
      case "saas":
        sysUrl = "https://hr.hina.com";
        break;
      default:
        break;
    }
    if (sysUrl) {
      window.open(sysUrl);
      this.showSelectHina = false;
    }
  }
  showCompany() {
    this.vuexStores.updateShowCompany(!this.vuexStores.showCompany);
  }
  //延迟隐藏
  laterHide(d: string) {
    this[d + "Timer"] = setTimeout(() => {
      this[d] = false;
    }, 200);
    console.log(this[d + "Timer"]);
  }
  //进入list 取消延迟隐藏
  cancelHide(d: string) {
    this[d] = true;
    clearTimeout(this[d + "Timer"]);
  }
  showUdesk() {
    //
  }
}
